import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "This section allows you to calculate the reverberation time of a simple room based on Sabine's or Eyring's equation. Modify the dimensions and the absorption coefficients and observe the effect on the reverberation time.",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "iframe",
            options: {
              src: `${config.IFRAMES_STATIC_URL}/0307/`,
            },
          },
        },
      },
    },
  },
};

export default principle;
